<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-1">
<div class="heading heading-with-title heading-without-image" id="chapter-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">1</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-1-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">W</span>hen the smiling anaesthetist leaned over Eban’s scrubbed and prepped body, he asked him to count backwards from ten. The anaesthetic pressed down upon him in what felt like a relentless wave of shimmering, chemical subjugation.</p>
<p class="subsq">A calm voice in his head told him that he was about to die for some short while.</p>
<p class="subsq">But unlike Elvis, he would never leave the building.</p>
<p class="subsq">Momentarily, a brief eddy of recent and long passed memories bled together.</p>
<p class="subsq">But no corridor of light.</p>
<p class="subsq">No celestial waiting room for him.</p>
<p class="subsq">Just the clunk and hiss of pumps and tubes. Pushing thin red lines down drip, up catheter. Nothingness.</p>
<p class="subsq">Not fear. Nor regret.</p>
<p class="subsq">Nor suffering.</p>
<p class="subsq">Nor loss</p>
<p class="subsq">Just void.</p>
<p class="subsq">Until returning, dulled and sore, perhaps to touch her hand and see her face again.</p>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center"><b>10</b></p>
<p class="alignment-block-content alignment-block-content-center"><b>9</b></p>
<p class="alignment-block-content alignment-block-content-center"><b>8</b></p>
<p class="alignment-block-content alignment-block-content-center"><b>7</b></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter-001.vue?695204ed